export default (num: number, precision: number) => {
  const multiplier = 10 ** precision;

  return Math.round((num + Number.EPSILON) * multiplier) / multiplier;
};
